export default "__VITE_ASSET__Dcddz__5__"